<template>
  <section>
    <v-dialog
      v-model="dialog"
      width="330px">
      <div class="dialog-container">
        <div class="dialog-header">
          <span>Send {{ isEmail? 'Email': 'SMS' }}</span>
        </div>
        <div class="dialog-body">
          <el-form
            ref="send-form"
            :rules="rules"
            :model="sendFormData">
            <div
              v-if="allSelect&&!isRenew"
              class="form-item">
              <el-form-item
                ref="send_type"
                prop="send_type"
                :rules="rules.select">
                <v-radio-group
                  v-model="sendFormData.send_type"
                  :list="sendList"
                />
              </el-form-item>

            </div>
            <div class="form-item">
              <span>{{isRenew?'Referrer':'Customer'}}</span>
              <!--            <div>-->
              <!--              <span>{{ !isEmail?currentName+'-':'' }} {{ currentContact }}</span>-->
              <!--            </div>-->
              <el-form-item >
                <v-input
                  :value="allSelect?sendContact:`${ !isEmail?currentName+' - ':''} ${currentContact}`"
                  disabled
                />
              </el-form-item>

            </div>
            <div
              v-if="isEmail && !!emailListTitle"
              class="form-item">
              <span>Email list title</span>
              <div>
                <span>{{emailListTitle}}</span>
              </div>
            </div>
            <div
              v-if="isEmail && !!emailTitle"
              class="form-item">
              <span>Title</span>
              <div>
                <span>{{emailTitle}}</span>
              </div>
            </div>
            <div class="form-item">
              <span>Content</span>
              <el-form-item prop="content">
                <v-input
                  v-model="sendFormData.content"
                  type="textarea"
                  :rows="4" />
              </el-form-item>
            </div>
          </el-form>
          <div class="flex-sb-center">
            <div>
              <v-button @click="onCancel">Cancel</v-button>
            </div>
            <div>
              <v-button
                v-if="skip"
                @click="onSkip">Skip</v-button>
              <v-button
                type="success"
                @click="onSend">Send</v-button>
            </div>
          </div>
        </div>
      </div>
    </v-dialog>
  </section>
</template>
<script>
import MixinRules from '@/mixins/rules'
import MixinOptions from '@/mixins/options'

export default {
  name: 'SendEmailSmsDialog',
  mixins: [MixinRules,MixinOptions],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    orderId: {
      type: [String, Number],
      default: ''
    },
    initContent: {
      type: String,
      default: ''
    },
    skip: {
      type: Boolean,
      default: true
    },
    showUsername:{
      type: Boolean,
      default: false
    },
    isEdit:{
      type: Boolean,
      default: false
    },
    isRenew:{
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: 0
    },
    updateContent: {
      type: Boolean,
      default: false
    },
    allSelect: {
      type: Boolean,
      default: false
    },
    emailListTitle: {
      type: String,
      default: ''
    },
    emailTitle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialog: false,
      sendFormData: {
        content: '',
        send_type:''
      }
    }
  },
  computed: {
    referrer(){
      let {referrer} = this.form||{}
      return referrer||{}
    },
    referSendValue(){
      let {isrd_nm,send_mobile} = this.referrer||{}
      return `${isrd_nm} - ${send_mobile}`
    },
    isEmail() {
      if(this.type == 0) {
        return !this.isPersonal
      }
      if(this.type == 2) {
        return true
      }
      return false
    },
    isPersonal() {
      const { identity, cust_typ } = this.form||{}
      if(identity && identity == 1) {
        return true
      }
      if(cust_typ && cust_typ == 1) {
        return true
      }
      return false
    },
    currentName() {
      const { isrd_lst_nm, isrd_fst_nm, contact_nm, isrd_nm } = this.form||{}
      let name = ''
      if(isrd_nm){
        name = isrd_nm
      }else{
        name =  `${isrd_lst_nm} ${isrd_fst_nm}`
      }
      // if(this.isPersonal) {
      //   return `${isrd_lst_nm} ${isrd_fst_nm}`
      // }
      return contact_nm||name
    },
    sendContact(){
      let {send_type} = this.sendFormData||{}
      const {
        mobile_no,
        contact_email,
        phone,
        email,
        contact_phone,
        phone_no } = this.form||{}
      let send_phone = contact_phone||mobile_no || phone || phone_no
      if(this.isRenew){
        return this.referSendValue
      }
      if(send_type==3) {
        return this.currentName?`${this.currentName} - ${send_phone},${email}`:`${send_phone},${email}`
      }
      if(send_type==2)
        return  this.currentName?`${this.currentName} - ${email}`:email
      return  this.currentName?`${this.currentName} - ${send_phone}`:send_phone

    },
    currentContact() {
      const {
        mobile_no,
        contact_email,
        phone,
        email,
        user_name,
        contact_phone,
        phone_no } = this.form||{}
      if(this.showUsername)
        return user_name
      if(this.isPersonal) {
        if(this.isEmail) {
          return email
        }
        // account detail customer_profile 這裏用的 phone
        return contact_phone||mobile_no || phone || phone_no
      }

      if(!this.isEmail) {
        return contact_phone
      }
      if(this.isEdit&&!this.isPersonal)
        return  email
      return contact_email||email
    }
  },
  watch: {
    initContent: {
      immediate: true,
      handler(val, old) {
        if(val != old && (!this.sendFormData.content || this.updateContent)) {
          this.sendFormData.content = val
        }
      }
    },
    dialog: {
      //   immediate: false,
      handler(val) {
        if(!val) {
          this.$emit('close')
        }else{
          this.formData = this.form
        }
      }
    }
  },
  methods: {
    changeDialog() {
      this.dialog = !this.dialog
    },
    onCancel() {
      this.$emit('cancel')
      this.dialog = false
    },
    onSend() {
      this.$refs['send-form'].validate((valid, rules) => {
        if(valid) {
          this.dialog = false
          let {send_type} = this.sendFormData||{}
          this.$emit('send', this.sendFormData.content,send_type)
        }
        else {
          console.log(rules)
        }
      })
    },
    onSkip() {
      this.dialog = false
      this.$emit('skip')
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog{
  box-sizing: border-box;
  border-radius: 6px;
}
.dialog-container {

  .dialog-header {
    padding: 16px;
    background: #F6F8FA;
    border-bottom: 1px solid #E1E4E8;
    border-radius: 6px 6px 0 0;
    span{
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: #1B1F23;
    }
  }
  .dialog-body{
    padding: 20px 15px;
  }
      h3 {
        padding-bottom: 10px;
      }
      p {
        padding-bottom: 10px;
      }
      .dialog-footer {
        margin: 15px -15px -15px;
        padding: 15px;
        text-align: right;
        background: #F9FAFB;
      }
      .form-item {
          & > span {
              font-weight: 600;
              font-size: 14px;
          }
      }
    }
</style>
